// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import _ from 'underscore';

// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';

import { markdownAsHtml } from 'app/scripts/lib/markdown/format';
import { pluginIOCache } from 'app/scripts/views/internal/plugins/PluginIoCache';
import { recupWithHelpers } from 'app/scripts/views/internal/recupWithHelpers';
import { PowerUpItemType } from 'app/src/components/PowerUp';
import { BaseDirectoryView } from './BaseDirectoryView';
import { DirectoryLegacyPowerUps as directoryLegacyPowerUps } from './DirectoryLegacyPowerUps';
import { DirectoryPluginItemView } from './DirectoryPluginItemView';
const t = recupWithHelpers('directory');
const c = recupWithHelpers('directory_data_consent');
import { Component } from 'react';

import { renderComponent } from '@trello/component-wrapper';

import { isValidHttp } from 'app/scripts/lib/plugins/pluginValidators';
import { LazyPowerUpsDeprecationBanner } from 'app/src/components/PowerUpsDeprecationBanner/LazyPowerUpsDeprecationBanner';
import { applyBidiTooltip } from 'app/src/components/TrelloMarkdown/applyBidiTooltip';

import compliantIcon from 'resources/images/directory/icons/compliant.svg';
import notCompliantIcon from 'resources/images/directory/icons/notCompliant.svg';

class DirectoryListing extends Component {
  static initClass() {
    // @ts-expect-error TS(2339): Property 'displayName' does not exist on type 'Dir... Remove this comment to see the full error message
    this.prototype.displayName = 'Directory Listing';

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.prototype.render = t.renderable(function (this: any) {
      const {
        supportEmail,
        description,
        displayName,
        isCompliant,
        privacyPolicy,
        categories,
        onCategoryClick,
        isDeprecated,
      } = this.props;

      return t.div('.directory-individual-listing', function () {
        t.div('.js-directory-listing');
        if (supportEmail) {
          let supportLink = supportEmail;

          const EMAIL_REGEX = /^[^@]+@[a-z0-9-]+(\.[a-z0-9-]+)+$/i;

          if (EMAIL_REGEX.test(supportLink)) {
            supportLink = `mailto:${supportEmail}?subject=${encodeURIComponent(
              displayName,
            )}`;
          }

          t.div('.directory-listing-support', () =>
            t.div('.support-list', function () {
              t.icon('email', { class: 'icon-lg' });
              t.a('.support-link', { href: supportLink }, () =>
                t.format('contact-support'),
              );
              if (isValidHttp(privacyPolicy)) {
                t.icon('information', { class: 'icon-lg' });
                return t.a('.support-link', { href: privacyPolicy }, () =>
                  t.format('privacy-policy'),
                );
              }
            }),
          );
        } else {
          t.div('.directory-listing-categories', function () {
            t.icon('information', { class: 'icon-lg' });
            return t.div('.categories-list', () =>
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              categories.map((category: any, index: any) => {
                if (index > 0) {
                  t.span('.category-link-delimiter', () => t.text('•'));
                }
                t.a(
                  '.category-link',
                  {
                    href: '#',
                    onClick() {
                      return onCategoryClick(category);
                    },
                  },
                  () => t.format(category),
                );
              }),
            );
          });
        }
        if (isDeprecated) {
          t.div('.directory-listing-deprecation-warning');
        }
        t.div(
          '.directory-listing-content.markeddown',
          {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ref: (node: any) => {
              if (node) {
                applyBidiTooltip(node);
              }
            },
          },
          () => t.raw(markdownAsHtml(description)),
        );
        return t.div('.directory-listing-compliance', function () {
          const src = isCompliant === false ? notCompliantIcon : compliantIcon;

          c.img('.directory-listing-compliance-icon', {
            src,
            alt: '',
            role: 'presentation',
          });
          if (isCompliant === false) {
            return c.format(
              'power-up-does-not-comply-with-our-data-privacy-standards',
              { pluginName: displayName },
            );
          } else if (isCompliant === true) {
            return c.format(
              'power-up-stores-data-complies-with-our-data-privacy-standards',
              { pluginName: displayName },
            );
          } else {
            return c.format(
              'power-up-complies-with-our-data-privacy-standards',
              { pluginName: displayName },
            );
          }
        });
      });
    });
  }
}

DirectoryListing.initClass();

// @ts-expect-error
interface DirectoryListingView extends BaseDirectoryView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  currentPage: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  directoryView: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  io: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  isDeprecated: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  isGrandfathered: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  plugin: any;
}

class DirectoryListingView extends BaseDirectoryView {
  static initClass() {
    // @ts-expect-error TS(2322): Type 'string' is not assignable to type '() => str... Remove this comment to see the full error message
    this.prototype.className = 'directory-listing-wrapper';
  }
  eventSource() {
    return 'boardDirectoryPowerUpDetailsScreen';
  }

  // @ts-expect-error TS(2416): Property 'initialize' in type 'DirectoryListingVie... Remove this comment to see the full error message
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  initialize({ directoryView, plugin, currentPage }: any) {
    this.directoryView = directoryView;
    this.plugin = plugin;
    this.currentPage = currentPage;

    // @ts-expect-error TS(2556): A spread argument must either have a tuple type or... Remove this comment to see the full error message
    super.initialize(...arguments);

    this.isDeprecated = this.plugin.get('deprecation')?.sunsetDate;

    this.io = pluginIOCache.get(this.plugin);

    const powerUp = _.findWhere(directoryLegacyPowerUps, {
      id: this.plugin.id,
    });

    if (powerUp) {
      let needle;
      const { name } = powerUp;
      return (this.isGrandfathered =
        ((needle = name),
        Array.from(this.model.get('powerUps')).includes(needle)));
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  navigateToCategory(category: any) {
    return this.directoryView.navigate({ section: 'category', category });
  }

  renderContent() {
    return (
      <DirectoryListing
        // @ts-expect-error TS(2769): No overload matches this call.
        displayName={this.io.getName()}
        description={this.io.getDescription()}
        supportEmail={this.plugin.get('supportEmail')}
        privacyPolicy={this.plugin.get('privacyUrl')}
        categories={this.plugin.get('categories')}
        isGrandfathered={this.isGrandfathered}
        /* eslint-disable-next-line react/jsx-no-bind, @typescript-eslint/no-explicit-any */
        onCategoryClick={(category: any) => this.navigateToCategory(category)}
        isCompliant={this.plugin.get('isCompliantWithPrivacyStandards')}
        isDeprecated={this.isDeprecated}
        isIntegration={(this.plugin.get('tags') || []).includes('integration')}
      />
    );
  }

  render() {
    // @ts-expect-error TS(2556): A spread argument must either have a tuple type or... Remove this comment to see the full error message
    super.render(...arguments);

    if (this.isDeprecated) {
      const deprecatedBannerReactRoot = this.el.querySelector(
        '.directory-listing-deprecation-warning',
      );

      renderComponent(
        <LazyPowerUpsDeprecationBanner
          deprecatedPowerUps={[
            {
              ...this.plugin.get('deprecation'),
              name: this.io.getName(),
            },
          ]}
        />,
        deprecatedBannerReactRoot,
      );
    }

    this.appendSubview(
      this.subview(
        DirectoryPluginItemView,
        this.model,
        {
          atomType: PowerUpItemType.Listing,
          plugin: this.plugin,
          currentPage: this.currentPage,
          directoryView: this.directoryView,
        },
        this.plugin.id,
      ),
      $('.js-directory-listing', this.$el),
    );

    const enabledPlugins = this.directoryView.getEnabledPlugins();

    this.directoryView.trackScreenEvent(this.eventSource(), {
      powerUpId: this.plugin.id,
      // @ts-expect-error TS(2769): No overload matches this call.
      isEnabled: _.some(enabledPlugins, { id: this.plugin.id }) ? true : false,
      tags: this.plugin.get('tags'),
    });

    return this;
  }
}

DirectoryListingView.initClass();
export { DirectoryListingView };
